import "./App.css";
import Homepage from "./pages/Homepage";
import {
  BrowserRouter,
  Navigate,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import "./styles/style.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import EntryPage from "./pages/EntryPage";
import { useEffect } from "react";
import RegisterUser from "./pages/RegisterUser";
import LoginPage from "./pages/LoginPage";
import NotFound from "./pages/NotFound";
import useAuth, { Authentication } from "./useAuth";
import { ProfilePage } from "./pages/ProfilePage";

function App() {
  const Scroll = (props) => {
    const location = useLocation();

    useEffect(() => {
      window.scrollTo(0, 0);
    }, [location]);
    return props.children;
  };

  const { user } = useAuth();
  return (
    <BrowserRouter>
      <ToastContainer position="top-right" />
      <Authentication>
        <Scroll>
          <Routes>
            <Route path="login" element={<LoginPage />} />
            <Route path="*" element={<NotFound />} />
            <Route path="/" element={<Navigate to="/my" />} />
            <Route path="/my" element={<EntryPage />}>
              <Route path="" element={<Navigate to="home" />} />

              <Route path="home" element={<Homepage />} />
              <Route path="registerUser" element={<RegisterUser />} />

              <Route path="profile" element={<ProfilePage />} />
            </Route>
          </Routes>
        </Scroll>
      </Authentication>
    </BrowserRouter>
  );
}

export default App;
